import '../CsvJsonInfoPages.scss';


function NVDBodyStyle() {

    const data = [
        { field: 1, description: 'Trim Code (Int)' },
        { field: 2, description: 'Trim Description (Char)' },
        { field: 3, description: 'Manufacturer Code (Int)' },
        { field: 4, description: 'Model Range Code (Int)' },
        { field: 5, description: 'Model Code (Int)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - NVD Body Style</h1>
            <p>Provides a list of Body Styles<br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />
                CAR_yyyy-mm-dd_NVDBodyStyle.tx <br />
                LIGHTS_yyyy-mm-dd_NVDBodyStyle.txt<br /><br />

                represents the date of t he product.E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default NVDBodyStyle;
